/**
 * Filter Products — Supperfrigo
 *
 * Tabs .products-tab[data-filter] filtram cards .box-product pelo data-line
 * do .pcard interno (delivery, truck, srf). data-filter="all" mostra todos.
 * Escopado por instância de .sec-products (funciona em home + page-maquinas).
 *
 * No small (≤575) as tabs viram <select class="products-tabs-select"> gerado
 * ao lado do wrapper. O CSS controla a visibilidade por breakpoint
 * (ver _home.scss .sec-products .products-tabs / .products-tabs-select).
 */
(function ($) {
    'use strict';

    function applyFilter($tabs, $cards, filter) {
        $tabs.find('.products-tab').each(function () {
            var $b = $(this);
            $b.toggleClass('active', ($b.data('filter') || 'all').toString() === filter);
        });

        $cards.each(function () {
            var $box = $(this);
            var line = ($box.find('.pcard').data('line') || '').toString();

            if (filter === 'all' || line === filter) {
                $box.removeAttr('hidden');
            } else {
                $box.attr('hidden', true);
            }
        });
    }

    function buildSelect($tabs) {
        var $buttons = $tabs.find('.products-tab');
        if (!$buttons.length) return null;

        var $select = $('<select class="products-tabs-select" aria-label="Filtrar produtos"></select>');

        $buttons.each(function () {
            var $b = $(this);
            var $opt = $('<option></option>')
                .attr('value', ($b.data('filter') || 'all').toString())
                .text(($b.text() || '').trim());
            if ($b.hasClass('active')) $opt.prop('selected', true);
            $select.append($opt);
        });

        $tabs.after($select);
        return $select;
    }

    $(function () {
        $('.sec-products').each(function () {
            var $sec   = $(this);
            var $tabs  = $sec.find('.products-tabs');
            var $cards = $sec.find('.box-product');

            if (!$tabs.length || !$cards.length) return;

            var $select = buildSelect($tabs);

            $tabs.on('click', '.products-tab', function () {
                var filter = ($(this).data('filter') || 'all').toString();
                applyFilter($tabs, $cards, filter);
                if ($select && $select.length) $select.val(filter);
            });

            if ($select && $select.length) {
                $select.on('change', function () {
                    applyFilter($tabs, $cards, $(this).val() || 'all');
                });
            }
        });
    });
})(jQuery);
